<script>
    import {PATH_PREFIX} from '../../../apiUrls.js';
    import {sgettext} from '../../../i18n.js';
    import {submit} from '../../Form/utils.js';

    export let row = null;
    export let options = [];
    export let template = false;

    export let operationWorkSequencesUpdateHandler = () => {};
    let selectedId = row.task_list_operation? row.task_list_operation.id : null;
    let sending = false;
    let updateUrl = `${PATH_PREFIX}/sw/v2/api/work_sequence_task_list_operations/`;  // {% url 'internal-v2:work-sequence-task-list-operations-detail' pk %}

    async function saveOperationMapping() {
        try {
            if (!sending) {
                sending = true;
                let url = `${updateUrl}${row.id}/`;
                let payload = {...row, task_list_operations: [selectedId]};
                let method = 'PUT';
                await submit(url, method, payload);
                row.task_list_operation = options.filter(x => x.id === selectedId)[0];
                operationWorkSequencesUpdateHandler();
            }
        } catch (err) {}

        sending = false;
    }

    //auto-map operations if there is only one operation
    $: if (selectedId === null && options.length == 1) {
         if (options.length == 1) {
             selectedId = options[0].id;
             saveOperationMapping();
         }
     }
</script>

<style>
    .unmapped {
        border-color: rgba(213, 40, 40, 0.68);
    }

    .user-defined {
        border-color: #f77f00;
    }
</style>

<select bind:value={selectedId}
        on:change={saveOperationMapping}
        class:unmapped={selectedId == null}
        class:user-defined={row.task_list_operation?.operation.user_defined}
        class="custom-select d-inline-block"
        disabled={sending || !template}>
    <option value={null} disabled>{sgettext('$$SELECT_OPERATION$$')}</option>
    {#each options as option}
        {#if option.operation.user_defined}
            <option value={option.id} class="text-warning">
                 {option.operation.number} - {sgettext("$$USERDEFINED$$")}
            </option>
        {:else}
            <option value={option.id}>
                 {option.operation.number} - {option.operation.description} - {option.operation.resource_work_centre}
            </option>
        {/if}
    {/each}
</select>
